import React from 'react';
import { Modal } from '../Modal';
import { IncaricoMedia } from '../../types';

interface Props {
    file: IncaricoMedia & { isFieldMedia?: boolean };
    onClose: () => void;
}

export const PreviewModal: React.FC<Props> = ({ file, onClose }) => {
    const isVideo = file.fileType?.includes('video') || file.finalUrl?.toLowerCase().endsWith('.mp4');

    return (
        <Modal title="Dettaglio Prova" onClose={onClose}>
            <div className="flex flex-col items-center bg-slate-900 -mx-5 -mb-5 p-6 rounded-b-xl overflow-hidden">
                {isVideo ? (
                    <video
                        src={file.urlCompressed || file.finalUrl}
                        controls
                        preload="metadata"
                        autoPlay
                        className="w-full rounded-xl shadow-2xl max-h-[60vh] object-contain bg-black"
                    />
                ) : (
                    <img
                        src={file.urlCompressed || file.finalUrl}
                        alt="Anteprima"
                        className="w-full rounded-xl shadow-2xl max-h-[60vh] object-contain"
                    />
                )}
                <div className="w-full mt-4 flex items-center justify-between text-slate-300">
                    <span className="text-xs font-medium truncate pr-4">{file.filename}</span>
                    <button
                        onClick={() => window.open(file.finalUrl, '_blank')}
                        className="text-[10px] font-bold uppercase tracking-wider bg-slate-800 hover:bg-slate-700 px-3 py-1 rounded transition-colors"
                    >
                        Apri Originale
                    </button>
                </div>
            </div>
        </Modal>
    );
};
